type Product = {
  id: number
  img: string
  name: string
  image: string
  brand: string
  category: string
  upchargePrice: number
  isLimitedEdition: boolean
}

type Volume = {
  price: number
  volume: string
  id: number
  oz: string
  productGroup: string
  colorName?: string
  img?: string
}

type Merged = Omit<Product & Volume, 'oz'>

const getMergedProductAndVolume = (product: Partial<Product> = {}, volume: Partial<Volume> = {}, forExtra?: boolean): Merged => {
  let nextProductInfo = {
    id: product.id,
    img: product.img, // TODO remove img format @akopylov 16.06.2020
    image: product.image,
    name: product.name,
    brand: product.brand,
    category: product.category,
    upchargePrice: product.upchargePrice,
    isLimitedEdition: product.isLimitedEdition,
    price: volume.price,
    volume: volume.volume,
    tradingId: volume.id,
    volumeUnit: volume.oz,
    productGroup: volume.productGroup,
  }

  if (forExtra) {
    // TODO @s3rios, why category?
    const name = volume.colorName
      ? `${volume.colorName} ${product.category}`
      : product.name

    nextProductInfo = {
      ...nextProductInfo,
      img: volume.img,
      name,
    }
  }

  return nextProductInfo
}


export default getMergedProductAndVolume
